import _toConsumableArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import configureStore, { browserHistory, Provider, Router } from '@clearscore-group/lib.redux.store';
import { selectors } from '@clearscore-group/lib.redux.market';
import i18n from 'i18next';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
import monitoring from '@clearscore-group/lib.helpers.monitoring';
import { MARKETS, EN_GB, EN_AU, EN_CA, EN_ZA, FR_CA, EN_NZ } from '@clearscore-group/lib.config.i18n';
import { getSessionCookie, updateSessionCookie, constants } from '@clearscore-group/lib.helpers.cookies';
import { isValidLocale } from '@clearscore-group/lib.helpers.i18n';

/* eslint-disable camelcase */
var sessionCookie = {
  name: 'sessionCookie',
  lookup: function lookup() {
    try {
      var sessionCookieObj = getSessionCookie();
      return isValidLocale(sessionCookieObj.locale) ? sessionCookieObj.locale : undefined;
    } catch (_unused) {
      return undefined;
    }
  }
};
var marketPath = {
  name: 'marketPath',
  lookup: function lookup() {
    if (typeof window !== 'undefined') {
      var _regExp$exec$, _regExp$exec, _ref;
      var regExp = new RegExp([].concat(_toConsumableArray(MARKETS.map(function (market) {
        return "/".concat(market, "/");
      })), _toConsumableArray(MARKETS.map(function (market) {
        return "/".concat(market, "$");
      }))).join('|'));
      var result = (_regExp$exec$ = (_regExp$exec = regExp.exec(window.location.pathname)) === null || _regExp$exec === void 0 ? void 0 : _regExp$exec[0]) !== null && _regExp$exec$ !== void 0 ? _regExp$exec$ : [];
      var possibleMarket = (_ref = "en-".concat(result[1]).concat(result[2])) !== null && _ref !== void 0 ? _ref : '';
      return isValidLocale(possibleMarket) ? possibleMarket : undefined;
    }
    return undefined;
  }
};
var CS_CURRENT_LANGUAGE = constants.CS_CURRENT_LANGUAGE;
var languageDetector = new LanguageDetector(null, {
  caches: ['cookie'],
  order: ['querystring', marketPath.name, sessionCookie.name, 'cookie', 'navigator'],
  lookupCookie: CS_CURRENT_LANGUAGE
});
var supportedLngs = [EN_GB, EN_AU, EN_CA, EN_ZA, FR_CA, EN_NZ];
languageDetector.addDetector(marketPath);
languageDetector.addDetector(sessionCookie);
i18n.use(initReactI18next).use(ICU).use(languageDetector).init({
  ns: [],
  resources: {
    EN_GB: {}
  },
  supportedLngs: supportedLngs,
  lowerCaseLng: true,
  fallbackLng: EN_GB,
  interpolation: {
    escapeValue: false
  },
  saveMissing: true,
  missingKeyHandler: function missingKeyHandler(locale, ns, copyKey) {
    // don't throw for copy tagged as coming from a feature service
    if (monitoring.hasMonitoring() && ns !== 'cs-dont-throw') {
      var errObject = new Error("[i18n.missing-key] local: ".concat(locale, ", Scope: ").concat(ns, ", Copy-key: ").concat(copyKey));
      monitoring.error(errObject);
    }
  }
});
i18n.on('languageChanged', function (lng) {
  if (getSessionCookie()) updateSessionCookie({
    locale: lng
  });
});
var _excluded = ["children", "storeConfig", "i18n", "defaultMarket", "defaultLocale", "basename", "history"];
var isFunction = function isFunction(config) {
  return typeof config === 'function';
};
var i18nInstance = i18n;
var index = function index(_ref) {
  var children = _ref.children,
    storeConfig = _ref.storeConfig,
    _ref$i18n = _ref.i18n,
    newI18nInstance = _ref$i18n === void 0 ? i18n : _ref$i18n,
    defaultMarket = _ref.defaultMarket,
    defaultLocale = _ref.defaultLocale,
    basename = _ref.basename,
    _ref$history = _ref.history,
    history = _ref$history === void 0 ? browserHistory(basename) : _ref$history,
    props = _objectWithoutProperties(_ref, _excluded);
  var store = isFunction(storeConfig) ? storeConfig : configureStore(_objectSpread(_objectSpread({}, storeConfig), {}, {
    defaultLocale: defaultLocale,
    defaultMarket: defaultMarket,
    history: history
  }));
  var state = store.getState();
  var locale = selectors.getActiveLocale(state);
  var providerProps = _objectSpread({
    store: store,
    history: history,
    locale: locale
  }, props);
  var getChild = function getChild() {
    return isFunction(children) ? children(providerProps) : children;
  };
  return /*#__PURE__*/React.createElement(Provider, _objectSpread({}, providerProps), /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: newI18nInstance
  }, getChild())));
};
export default index;
export { i18nInstance };